module.exports = __webpack_public_path__ + "img/center01.5c65f87e.jpg";